import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import MaterialTable from 'material-table';
import React, { useEffect, useRef, useState } from 'react'
import tableIcons from '../../../utils/tableIcons';
import { GetNotifications } from '../../../utils/api';
import dayjs from 'dayjs';

const EmailNotification = ({ activeTab }) => {
    const tableRef = useRef(null);

    const [query, setQuery] = useState({
        page: 0,
        pageSize: 10,
        search: '',
        orderField: '',
        orderDirection: '',
        customFilter: ''
    });

    const columns = [

        {
            title: 'Job Id',
            field: 'id',
            sorting: false,
            cellStyle: { width: '10%' },
        },
        {
            title: 'Template Used',
            field: 'title',
            sorting: false,
            cellStyle: { width: '25%' },
        },
        {
            title: 'User Type',
            field: 'user',
            cellStyle: { width: '10%' },
            sorting: false,
            render: (record) => {
                return (
                    <span className='capitalize'>{record?.user?.user_type}</span>
                )
            },
        },
        {
            title: 'Email',
            field: 'user',
            cellStyle: { width: '25%' },
            sorting: false,
            render: (record) => {
                return (
                    <span>{record?.user?.email}</span>
                )
            },
        },
        {
            title: 'Trigged On',
            field: 'created_at',
            cellStyle: { width: '20%' },
            sorting: false,
            render: (record) => {
                return (
                    <span>{dayjs(record.created_at).format('DD MMM, YYYY h:mm A')}</span>
                )
            },
        },
        {
            title: 'Status',
            field: 'is_read',
            cellStyle: { width: '10%' },
            sorting: false,
            render: (_record) => {
                return (
                    // <span className='capitalize'>{record.is_read === 0 ? 'Unread' : 'Read'}</span>
                    <span className='capitalize'>sent</span>
                )
            }
        },
        // {
        //     title: 'Action',
        //     sorting: false,
        //     cellStyle: { width: '15%' },
        //     align: 'center',
        //     render: () => {
        //         return (
        //             <button className='px-3 py-1 border border-[#E5B3B2] bg-[#E5B3B21A] text-[#E5B3B2] font-normal rounded-md text-[10px]'>
        //                 View Template
        //             </button>
        //         )
        //     },
        // },
    ];

    const fetchData = async (dataquery) => {

        let params = 'notification_type=email';

        if (dataquery?.search) {
            params += `&search=${dataquery.search}`;
        }

        if (dataquery?.orderBy) {
            params += `&sort=${dataquery?.orderBy.field}&order=${dataquery?.orderDirection}`;
        }

        params += `&pageNo=${dataquery?.page + 1}`;

        params += `&limit=${dataquery?.pageSize}`;

        const response = await GetNotifications(params);


        return {
            data: response?.items,
            page: dataquery?.page,
            totalCount: response?.totalRecords
        };
    };

    useEffect(() => {
        tableRef.current.onQueryChange();
    }, [activeTab]);

    return (
        <div className="searchposotion table-scroll">

            <MaterialTable
                title="Email Notifications"
                tableRef={tableRef}
                columns={columns}
                icons={tableIcons}
                page={query.page}
                options={{
                    showTitle: false,
                    draggable: false,
                    paging: true,
                    sorting: true,
                    search: true,
                    pageSize: query.pageSize,
                    pageSizeOptions: [10, 25, 50, 100],
                    debounceInterval: 700,
                    padding: 'dense',
                    paginationType: 'stepped',
                    searchFieldVariant: 'outlined',
                    searchFieldAlignment: 'left',
                }}
                data={query => fetchData(query)}
                onChangeRowsPerPage={(pageSize => {
                    setQuery(prev => ({ ...prev, pageSize: Number(pageSize) }));
                })}
                onChangePage={(page => setQuery(prev => ({ ...prev, page: Number(page) })))}
                components={{
                    Pagination: (props) => {
                        const { page, rowsPerPage, count, onChangePage, onChangeRowsPerPage } = props;
                        return (
                            <div className="box-shadow-pagination" style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px', padding: '10px 20px' }}>
                                <div>
                                    <div className='bottom-pagination-text'>
                                        <button className='disabled:opacity-50' onClick={(e) => onChangePage(e, page - 1)} disabled={page === 0}><LeftOutlined /></button>
                                        <span style={{ margin: '0 10px' }}>{page + 1} of {Math.ceil(count / rowsPerPage)}</span>
                                        <button className='disabled:opacity-50' onClick={(e) => onChangePage(e, page + 1)} disabled={page === Math.ceil(count / rowsPerPage) - 1 || tableRef.current?.dataManager?.data?.length === 0}><RightOutlined /></button>
                                    </div>
                                </div>
                                <div style={{ position: 'absolute', right: '25px' }} >
                                    <span style={{ margin: '0 10px' }}>Items per page:</span>
                                    <select
                                        className='pagination-select'
                                        disabled={tableRef.current?.dataManager?.data?.length === 0}
                                        value={rowsPerPage}
                                        onChange={(e) => {
                                            onChangeRowsPerPage(e, e.target.value);
                                        }}>
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                </div>
                            </div>
                        );
                    },
                    // OverlayLoading: () => <div style={{ height: '100vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    //     <h2>Loading....</h2>
                    // </div>
                }}
            />
        </div>
    )
}

export default EmailNotification